module.exports = __webpack_public_path__ + "assets/img/aboutus_img_bg_left.960bd56f.svg";